import AircraftPopup from './components/AircraftPopup.css';
import AircraftPopupContent from './components/AircraftPopupContent/AircraftPopupContent.css';

export default {
	AircraftPopup,
	AircraftPopupContent
};
